export const getStoreQuery = (objectType = 'store', first = 50, after = '') => {
  return `query @inContext(country: ${Shopify.country}, language: ${Shopify.locale.toUpperCase()}) {
    metaobjects(first: ${first}, type: "${objectType}", ${after != '' ? 'after: "' + after + '"' : ''}) {
      edges {
        node {
          id
          onlineStoreUrl
          fields {
            key
            type
            value
          }
          media: field(key: "media") {
            references(first: 10) {
              edges {
                node {
                  ...on Media {
                    id
                    previewImage {
                      url
                      width
                      height
                      altText
                    }
                  }
                  ...on Video {
                    id
                    sources {
                      url
                      format
                      mimeType
                      width
                      height
                    }
                    previewImage {
                      url
                      altText
                      width
                      height
                    }
                  }
                }
              }
            }
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }`
}
export const formatStoreData = (objectType = 'store', edge) => {
  const node = edge?.node
  if(objectType == 'store') {
    
    return {
      id: node.id,
      media: node.media?.references?.edges?.map((edge) => edge.node),
      address: node.fields.filter((field) => field.key == 'address_for_search')[0]?.value?.toLowerCase(),
      addressFull: node.fields.filter((field) => field.key == 'address')[0]?.value,
      title: node.fields.filter((field) => field.key == 'title')[0].value,
      directions: node.fields.filter((field) => field.key == 'directions')[0]?.value,
      hours: node.fields.filter((field) => field.key == 'hours')[0]?.value,
      email: node.fields.filter((field) => field.key == 'email')[0]?.value,
      phone: node.fields.filter((field) => field.key == 'phone')[0]?.value,
      zipcode: node.fields.filter((field) => field.key == 'zipcode')[0]?.value?.toLowerCase(),
      city: node.fields.filter((field) => field.key == 'city')[0]?.value?.toLowerCase(),
      country: node.fields.filter((field) => field.key == 'country')[0]?.value?.toLowerCase(),
      services: JSON.parse(node.fields.filter((field) => field.key == 'services')[0]?.value || '[]'),
      products: JSON.parse(node.fields.filter((field) => field.key == 'products')[0]?.value || '[]'),
      url: node.onlineStoreUrl,
      order: parseInt(node.fields.filter((field) => field.key == 'order')[0]?.value) || 300,
      code: node.fields.filter((field) => field.key == 'store_code')[0]?.value,
    }
  } else {
    return {
      id: node.id,
      media: node.media?.references?.edges?.map((edge) => node),
      address: node.fields.filter((field) => field.key == 'address')[0]?.value?.toLowerCase(),
      addressForSearch: node.fields.filter((field) => field.key == 'address_for_search')[0]?.value?.toLowerCase(),
      title: node.fields.filter((field) => field.key == 'title')[0].value,
      hours: node.fields.filter((field) => field.key == 'hours')[0]?.value,
      phone: node.fields.filter((field) => field.key == 'phone')[0]?.value,
      zipcode: node.fields.filter((field) => field.key == 'zipcode')[0]?.value?.toLowerCase(),
      city: node.fields.filter((field) => field.key == 'city')[0]?.value?.toLowerCase(),
      country: node.fields.filter((field) => field.key == 'country')[0]?.value,
      region: node.fields.filter((field) => field.key == 'region')[0]?.value,
      website: node.fields.filter((field) => field.key == 'website')[0]?.value,
    }
  }
}